import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router";
import type { HomePublicConfig } from "../../../api/home-config";
import { MediaImage } from "../../../components/MediaImage";

type Application = HomePublicConfig["characters"]["items"][number]["application"];
type HomeCharacterSceneProps = { materialName: string; application: Application };

/** 应用由后管明确指定；仅有图片时展示静态卡片，关联作品后才提供跳转。 */
export function HomeCharacterScene({ materialName, application }: HomeCharacterSceneProps) {
  if (!application) return null;
  const content = (
    <>
      <span className="home-character-scene-media">
        <MediaImage key={application.imageUrl} src={application.imageUrl} alt={application.title} />
        {application.href && (
          <span className="home-character-scene-hover" aria-hidden="true">
            去社区看看
          </span>
        )}
      </span>
      <span className="home-character-scene-copy">
        <small>真实应用</small>
        <strong>{application.title}</strong>
      </span>
      {application.href && (
        <i aria-hidden="true">
          <ArrowUpRight size={16} strokeWidth={1.8} />
        </i>
      )}
    </>
  );
  return application.href ? (
    <Link
      className="home-character-scene"
      to={application.href}
      aria-label={`真实应用：${application.title}，查看${materialName}相关作品`}
    >
      {content}
    </Link>
  ) : (
    <div className="home-character-scene is-static">{content}</div>
  );
}
